import type { Option } from '../Components/Common/NestedSelect'

export default (accounts: Option[]) => {
  return accounts
    .flatMap((item) =>
      [
        {
          id: item.id,
          label: item.name,
          value: item.id,
          platform: item.platform,
        },
      ].concat(
        item.group_options?.map((item) => ({
          id: item.id,
          label: item.name,
          value: item.id,
          platform: item.platform,
        })) ?? []
      )
    )
    .filter((item) => item.platform === 'instagram')
}
